module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVQImWNwqN30HwAE3wJvkKRGFwAAAABJRU5ErkJggg=="